module.exports = __webpack_public_path__ + "img/toscana-logo.3ceea2cd.svg";